
import { FormControl, FormLabel, Input} from '@chakra-ui/react';
import 'react-datepicker/dist/react-datepicker.css';
import React from "react";

const DateField = ({ label, value, onChange, required, ...rest }) => {
  const defaultValue = getDateValue(value);

  return (
    <FormControl mb={4}>
      <FormLabel>{label}{required && (<span style={{ color: 'red' }}>*</span>)}</FormLabel>
      <Input
        type="date"
        value={defaultValue}
        onChange={(date) => onChange(date.target.value)}
      />
    </FormControl>
  );
};

function getDateValue(value) {
  if (value && typeof value === 'string') {
     if (value.includes('T')) {
       return value.split('T')[0];
     }
     return value
  }
  return null;
}

export default DateField;